/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSimpliCity } from "cms/hooks/use-simplicity";
// import { useOrgSettings } from "hooks/use-org-settings";

const useFeatureFlag = (key) => {
    const { settings } = useSimpliCity();
    const textFlag = settings[key];
    return textFlag === "true";
};

// const useFeatureFlag = (feature) => {
//     const { getOrgSettingsBoolean } = useOrgSettings(feature);
//     const flag = getOrgSettingsBoolean(feature);
//     return flag;
// };

export { useFeatureFlag };
